export default __webpack_public_path__ + "static/media/highlight_score_5.ba6fe48c.svg";